import React, { useState } from 'react';
import { FaTrash, FaEdit, FaCheck, FaTimes } from 'react-icons/fa';
import { useModalLock } from '../hooks/useModalLock';
import './TransactionItem.css';

function TransactionItem({ transaction, onDelete, onUpdate }) {
  const [isEditing, setIsEditing] = useState(false);
  const [newDescription, setNewDescription] = useState(transaction.description);
  const [newDate, setNewDate] = useState(transaction.date);
  const [newAmount, setNewAmount] = useState(Math.abs(transaction.amount));
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useModalLock(showDeleteModal);

  const isIncome = transaction.amount >= 0;

  const handleSubmit = () => {
    if (!newDescription.trim() || !newDate || !newAmount) return;
    const raw = parseFloat(parseFloat(newAmount).toFixed(2));
    if (isNaN(raw) || raw <= 0) return;
    onUpdate(transaction.id, {
      ...transaction,
      description: newDescription.trim(),
      date: newDate,
      amount: isIncome ? Math.abs(raw) : -Math.abs(raw),
    });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setNewDescription(transaction.description);
    setNewDate(transaction.date);
    setNewAmount(Math.abs(transaction.amount));
    setIsEditing(false);
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

  if (isEditing) {
    return (
      <li className="titem">
        <div className="titem-edit">
          <div className="titem-edit-row">
            <input
              type="date"
              className="titem-edit-input date-input"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
            />
            <input
              type="number"
              step="0.01"
              min="0"
              className="titem-edit-input amount-input"
              value={newAmount}
              onChange={(e) => setNewAmount(e.target.value)}
              placeholder="0.00"
            />
          </div>
          <div className="titem-edit-row">
            <input
              type="text"
              className="titem-edit-input desc-input"
              value={newDescription}
              onChange={(e) => setNewDescription(e.target.value)}
              placeholder="Description"
              autoFocus
            />
            <button className="titem-edit-btn save" onClick={handleSubmit} title="Save">
              <FaCheck size={11} />
            </button>
            <button className="titem-edit-btn cancel" onClick={handleCancel} title="Cancel">
              <FaTimes size={11} />
            </button>
          </div>
        </div>
      </li>
    );
  }

  return (
    <>
      <li className="titem">
        <div className="titem-left">
          <span className={`titem-dot ${isIncome ? 'income' : 'expense'}`} />
          <div className="titem-info">
            <div className="titem-desc" onClick={() => setIsEditing(true)} title="Click to edit">
              {transaction.description}
            </div>
            <div className="titem-date">{formatDate(transaction.date)}</div>
          </div>
        </div>
        <div className="titem-right">
          <span className={`titem-amount ${isIncome ? 'income' : 'expense'}`}>
            {isIncome ? '+' : '−'}${Math.abs(transaction.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}
          </span>
          <div className="titem-actions">
            <button className="titem-btn" onClick={() => setIsEditing(true)} title="Edit">
              <FaEdit size={11} />
            </button>
            <button className="titem-btn delete" onClick={() => setShowDeleteModal(true)} title="Delete">
              <FaTrash size={11} />
            </button>
          </div>
        </div>
      </li>

      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h4 className="modal-title">Delete transaction?</h4>
            <p className="modal-desc">This action cannot be undone.</p>
            <div className="modal-info">
              <strong>Description:</strong> {transaction.description}<br />
              <strong>Amount:</strong> ${Math.abs(transaction.amount).toFixed(2)}<br />
              <strong>Date:</strong> {formatDate(transaction.date)}
            </div>
            <div className="modal-actions">
              <button className="modal-btn cancel-btn" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button className="modal-btn delete-btn" onClick={() => { onDelete(transaction.id); setShowDeleteModal(false); }}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TransactionItem;